import { Tag } from 'antd';
import { Condition, type JsonDataItem } from 'types';

enum Tags {
  Blacklist = 'blacklist',
  BadDebt = 'bad_debt',
  Overdue = 'overdue',
}

export const getCustomerTag = (customer: JsonDataItem) => {
  if (!customer) return null;

  const priorityTag = Object.values(Tags).find((tag) => customer[tag] === Condition.Yes);

  const tagText = (priorityTag: string) => {
    switch (priorityTag) {
      case Tags.Blacklist:
        return 'Blacklisted';
      case Tags.BadDebt:
        return 'Bad Debt';
      case Tags.Overdue:
        return 'Overdue';
      default:
        return null;
    }
  };

  return priorityTag ? <Tag key={`${customer.ID}-tag`}>{tagText(priorityTag)}</Tag> : null;
};
